import { Stack } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import useVidletNavigate from "hooks/navigation/useVidletNavigate";
import { useEffect } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import useScriptManagementStore from "../hooks/useScriptManagementStore";
import ScriptDetails from "./ScriptDetails";
import ScriptQuestions from "./ScriptQuestions";

export default function FormScript() {
  const { setCanNavigate } = useVidletNavigate();
  const { setHasScriptChange, hasScriptChange, handleStoreChange, script } =
    useScriptManagementStore();

  useEffect(() => {
    setHasScriptChange(false);
    handleStoreChange("editIndex", -1);
  }, [script.id]);

  useEffect(() => {
    setCanNavigate(!hasScriptChange);
  }, [hasScriptChange]);

  return (
    <Stack direction="column" sx={{ mb: 5 }}>
      <Grid item xs={12}>
        <ScriptDetails />
      </Grid>
      <Grid item xs={12}>
        <DndProvider backend={HTML5Backend}>
          <ScriptQuestions />
        </DndProvider>
      </Grid>
    </Stack>
  );
}
